import { render, staticRenderFns } from "./ele12.vue?vue&type=template&id=0783c94f&scoped=true"
import script from "./ele12.vue?vue&type=script&lang=js"
export * from "./ele12.vue?vue&type=script&lang=js"
import style0 from "./ele12.vue?vue&type=style&index=0&id=0783c94f&prod&lang=scss"
import style1 from "./ele12.vue?vue&type=style&index=1&id=0783c94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783c94f",
  null
  
)

export default component.exports